export enum Period {
    TwoWeeks = 'TwoWeeks',
    FourWeeks = 'FourWeeks',
    Custom = 'Custom',
}
